import { EnvironmentConfigItem } from "./models/environment-config.model";
import { EnvironmentNames } from "./models/environment-names.enum";

export function getEnvironments(...environmentKey: EnvironmentNames[]): EnvironmentConfigItem[] {
  return environmentConfigItems.filter(x => environmentKey.find(key => x.envKey == key));
}
export function getEnvironment(environmentKey: EnvironmentNames): EnvironmentConfigItem {
  return environmentConfigItems.find(x => x.envKey == environmentKey);
}

export const environmentConfigItems: EnvironmentConfigItem[] = [
  {
    envKey: EnvironmentNames.enterprise,
    envMessage: 'Ent - Local',
    environmentLabel: 'LOCAL',
    environmentEmoji: '🟢',
    apiRoot: "https://localhost:44368/api/v1",
  },
  {
    envKey: EnvironmentNames.test,
    envMessage: 'Test',
    environmentLabel: 'TEST',
    environmentEmoji: '🟠',
    hostNameMatch: 'pilexos-test.azurewebsites.net',
    apiRoot: "https://pilexos-test-api.azurewebsites.net/api/v1",
    useCDN: true,
    cdnRoot: "https://pilexos-test.b-cdn.net/api/v1"
  },
  {
    envKey: EnvironmentNames.testlocal,
    envMessage: 'TestLocal',
    environmentLabel: 'LOCAL',
    environmentEmoji: '🟢',
    apiRoot: "https://localhost:44370/api/v1",
  },
  {
    envKey: EnvironmentNames.stage,
    envMessage: 'Stage',
    environmentLabel: 'STAGE',
    environmentEmoji: '🟡',
    hostNameMatch: 'staging.pilexos.com',
    apiRoot: "https://pilexos-prod-api2-stage.azurewebsites.net/api/v1",
    useCDN: false, // Not setup and won't be (no reason)
    //cdnRoot: "https://pilexos-stage.b-cdn.net/api/v1"
  },
  {
    envKey: EnvironmentNames.sandbox,
    envMessage: 'Sandbox',
    environmentLabel: 'SANDBOX',
    environmentEmoji: '🟣',
    hostNameMatch: 'sandbox.pilexos.com',
    apiRoot: "https://pilexos-prod-api2-stage.azurewebsites.net/api/v1",
    useCDN: false, // Uses the staging API directly, matching the stage environment.
  },
  {
    envKey: EnvironmentNames.prod,
    envMessage: '',
    apiRoot: "https://api.pilexos.com/api/v1",
    useCDN: true,
    //cdnRoot: "https://pilexos-prod2.b-cdn.net/api/v1",
    cdnRoot: "https://cdn2.pilexos.com/api/v1"
    //cdnRoot: "https://cdn.pilexos.com/api/v1"
  },
  {
    envKey: EnvironmentNames.feature,
    envMessage: 'Feature',
    environmentLabel: 'Feature',
    environmentEmoji: '🔵',
    hostNameMatch: 'pilexos-feature.azurewebsites.net',
    apiRoot: "https://pilexos-feature-api.azurewebsites.net/api/v1",
    useCDN: true,
    cdnRoot: "https://pilexos-feature.b-cdn.net/api/v1"
  },
];
